
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component
export default class FormSelect extends Vue {
	@Prop({ default: null }) value!: any;
	@Prop({ default: () => [] }) options!: any[]; // Declare options as a prop
	@Prop({ type: String, default: '' }) readonly name!: string;
	@Prop({ type: String, default: 'Select' }) readonly placeholder!: string;
	@Prop({ type: Function, default: null }) readonly search!: (
		search: string,
		loading: (loading: boolean) => void
	) => void;
	@Prop({ type: String, default: "" }) readonly inputClass!: string;

	internalValue = this.value;
	internalIsLoading = false; // Internal state for loading

	@Watch('value', { immediate: true })
	onValueChange(newValue: any) {
		this.internalValue = newValue;
	}

	updateValue(newValue: any): void {
		this.$emit('input', newValue);
	}

	handleSearch(searchTerm: string) {
		if (this.search) {
			this.search(searchTerm, (loading: boolean) => {
				this.internalIsLoading = loading; // Update internal loading state
			});
		}
	}
	handleClose() {
		this.$emit('close');
	}
	get classes(): object {
    return {
      [this.inputClass]: true,
    };
  }
}
